'use client'

import { createContext, useContext } from 'react'

import type { Catalog } from '@/features/veluvit/types/catalog.types'

export const CatalogContext = createContext<Catalog | null>(null)

/** DataProvider 아래에서만 쓴다 — 카탈로그가 준비되기 전에는 화면을 그리지 않는다 */
export function useCatalog(): Catalog {
  const catalog = useContext(CatalogContext)
  if (!catalog)
    throw new Error('useCatalog 는 DataProvider 안에서만 사용할 수 있어요.')
  return catalog
}
